module.exports = __webpack_public_path__ + "static/media/IconTemplates_-28.5a41ecef.svg";